import React, { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Geçersiz sıfırlama bağlantısı. E-postadaki linki kullanın veya yeni talep oluşturun.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) return;

    if (password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır');
      return;
    }
    if (password !== password2) {
      setError('Şifreler eşleşmiyor');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Şifre güncellenemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-dark px-4">
      <div className="bg-gradient-card p-8 rounded-xl shadow-card border-2 border-gold/30 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center text-gold mb-8">Yeni Şifre</h1>

        {success ? (
          <div className="text-center space-y-4">
            <p className="text-emerald-200">Şifreniz güncellendi. Giriş sayfasına yönlendiriliyorsunuz...</p>
            <Link
              to="/login"
              className="inline-block text-gold hover:text-gold-light font-medium"
            >
              Hemen giriş yap
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <div>
              <label className="block text-white mb-2 font-medium">
                Yeni şifre <span className="text-gold">*</span>
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="En az 6 karakter"
                className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
                required
                minLength={6}
                autoComplete="new-password"
                disabled={!token}
              />
            </div>

            <div>
              <label className="block text-white mb-2 font-medium">
                Yeni şifre (tekrar) <span className="text-gold">*</span>
              </label>
              <input
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                placeholder="Şifreyi tekrar girin"
                className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
                required
                minLength={6}
                autoComplete="new-password"
                disabled={!token}
              />
            </div>

            <button
              type="submit"
              disabled={loading || !token}
              className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Kaydediliyor...' : 'Şifreyi güncelle'}
            </button>
          </form>
        )}

        <div className="mt-6 text-center">
          <Link to="/forgot-password" className="text-gold hover:text-gold-light text-sm">
            Yeni bağlantı iste
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
